export default "__VITE_ASSET__de32a552__"